import React from 'react';
import * as styles from './ThankYou.module.scss';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { HiArrowNarrowRight } from '@react-icons/all-files/hi/HiArrowNarrowRight';

const ThankYou = ({ type }) => {
    const getMessage = () => {
        if (type === 'contact') {
            return 'Thank you for contacting us!';
        } else if (type === 'application') {
            return 'Your application has been submitted!';
        } else {
            return 'Thank you for your generous donation!';
        }
    };

    const getQuote = () => {
        if (type === 'contact') {
            return (
                <h5>
                    We can change the world and make it a better place. <br />
                    It is in your hands to make a difference.
                    <br />
                    -Nelson Mandela
                </h5>
            );
        } else if (type === 'application') {
            return (
                <h5>
                    Even the greatest was once a beginner. <br />
                    Don't be afraid to take that first step.
                    <br />
                    -Muhammad Ali
                </h5>
            );
        } else {
            return (
                <h5>
                    No act of kindness, no matter how small, <br />
                    is ever wasted.
                    <br />
                    -Aesop
                </h5>
            );
        }
    };

    return (
        <div className={styles.thankYouContainer}>
            <div className={styles.header}>
                <h1>{getMessage()}</h1>
                {getQuote()}

                <Link className={styles.blueLink} to="/">
                    Back to Home
                </Link>

                <div className={styles.links}>
                    <div className={styles.linkItem}>
                        <div className={styles.imageContainer}>
                            <StaticImage
                                src="../images/thankyou-email.png"
                                alt="Explore"
                                className={styles.image}
                                objectFit="contain"
                                placeholder="blurred"
                            />
                        </div>

                        <h2>Check your email</h2>
                        <p>
                            You will receive a confirmation email. Contact us{' '}
                            <a href="mailto:shawnyip@digitalsocietyfund.org">
                                here
                            </a>{' '}
                            if you have not received your email.
                        </p>
                    </div>

                    <div className={styles.linkItem}>
                        <div className={styles.imageContainer}>
                            <StaticImage
                                src="../images/thankyou-explore.png"
                                alt="Explore"
                                className={styles.image}
                                objectFit="contain"
                                placeholder="blurred"
                            />
                        </div>

                        <h2>Keep exploring</h2>
                        <p>
                            Find our more about our scholarships and
                            initiatives.
                        </p>

                        <Link className={styles.link} to="/programmes">
                            Explore programmes
                            <HiArrowNarrowRight className={styles.icon} />
                        </Link>
                    </div>

                    <div className={styles.linkItem}>
                        <div className={styles.imageContainer}>
                            <StaticImage
                                src="../images/thankyou-donate.png"
                                alt="Explore"
                                className={styles.image}
                                objectFit="contain"
                                placeholder="blurred"
                            />
                        </div>

                        <h2>Lend a hand</h2>
                        <p>
                            Donate to our cause to democratize tech education.
                        </p>

                        <Link className={styles.link} to="/donate">
                            {type === 'donation' ? 'Donate more' : 'Donate now'}
                            <HiArrowNarrowRight className={styles.icon} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
